module.exports = __webpack_public_path__ + "static/img/10.ed3a4528.png";